export default {
    SET_STATISTICS(state, statisticdata) {
      state.statistics = statisticsdata;
    }
  }
  